import { assign } from 'lodash';
import EventEmitter from '@wsb/commerce-event-emitter';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';

class PreloadResourceStore extends EventEmitter {
  constructor() {
    super(...arguments);

    this.state = {
      resourcesPreloaded: false
    };
    this.register();
    // this.setMaxListeners(0);
  }

  setState(newState) {
    assign(this.state, newState);
    this.emit('change');
  }

  getState() {
    return this.state;
  }

  register() {
    this.dispatchToken = AppDispatcher.register(payload => {
      const { action } = payload;

      switch (action.type) {
        case 'RESOURCES_PRELOADED':
          this.setState({
            resourcesPreloaded: true
          });
          break;
        default:
          break;
      }
    });
  }
}

export default new PreloadResourceStore();
